module.exports = {"blocks":[{"type":"partials/hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"partials/download_app"}],"service_contents":[{"type":"service_headline2","content":"service_content"},{"type":"service_photos"},{"type":"service_comic"}],"service_content_photos":{"photo_grid":["documents","goods","valuables","food"]},"service_content_comic":{"photo_grid":["step_1","step_2","step_3"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/service/setting.json
// module id = 752
// module chunks = 0 1 2 3 4 5